import { render, staticRenderFns } from "./AdminBuildingHeightList.vue?vue&type=template&id=2f2cb9dc&"
import script from "./AdminBuildingHeightList.vue?vue&type=script&lang=js&"
export * from "./AdminBuildingHeightList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports